<template>
  <div>
    <div
      class="grid grid-cols-2 sm:grid-cols-3 w-full sm:gap-5 gap-1.5 transition-all duration-300"
    >
      <div class="relative" v-if="store.newArtwork.thumbnail">
        <BaseImage
          @contextmenu.prevent
          @dragstart.prevent
          :uri="store.newArtwork.thumbnail"
          :alt="
            store.newArtwork.title.hy ||
            store.newArtwork.title.en ||
            store.newArtwork.title.ru ||
            'Medium.am new artwork'
          "
          img-class="rounded-lg sm:h-60 sm:w-48 h-40 w-full rounded-lg  object-cover hover:object-contain transition-all hover:border border-gray-200 duration-300"
        />
        <div
          class="absolute left-0 bottom-0 p-1 flex items-center justify-between w-full"
        >
          <button
            type="button"
            class="text-center w-auto text-xs bg-white/50 px-2.5 py-0.5 rounded"
          >
            {{ $t("new.main_image") }}
          </button>
          <div class="size-6 min-w-6 opacity-0"></div>
        </div>
      </div>
      <div
        v-for="(image, i) in store.newArtwork.gallery"
        :key="i"
        class="overflow-hidden rounded-lg border border-gray-200"
      >
        <div class="relative">
          <BaseImage
            @contextmenu.prevent
            @dragstart.prevent
            :uri="image"
            :alt="`Gallery image ${i}`"
            img-class="sm:h-60 sm:w-48 h-40 w-full rounded-lg object-cover transition-all duration-300"
          />

          <div
            class="absolute bottom-0 left-0 p-1 flex items-center justify-between w-full"
          >
            <button
              @click="makeMainImage(image)"
              type="button"
              class="text-center w-auto text-xs bg-white/50 px-2.5 py-0.5 rounded cursor-pointer"
            >
              {{ $t("new.make_main") }}
            </button>
            <button
              @click="handleDelete(image)"
              :disabled="store.deleting"
              type="button"
              name="Delete"
              class="size-6 min-w-6 rounded-full bg-black/10 text-white flex items-center justify-center cursor-pointer hover:bg-black/50"
            >
              <Icon
                name="ph:circle-notch-thin"
                class="animate-spin"
                size="14"
                v-if="store.deleting && currentItem === image"
              />
              <Icon name="heroicons:trash" v-else size="14" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex ietms-center justify-center"
      :class="assetsCount > 0 ? 'pt-5' : ''"
      v-if="assetsCount < 3"
    >
      <BaseUpload
        :loading="uploadStore.uploading"
        @handle-upload="handleFileUpload"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AppUser } from "~~/types/user";

const uploadStore = useUploadStore();
const store = useNewArtworkStore();
const user = useState<AppUser | null>("auth-user", () => null);

const currentItem = ref<string | null>(null);
const fileName = computed<string>(
  () =>
    store.newArtwork.title.en ||
    store.newArtwork.title.hy ||
    store.newArtwork.title.ru ||
    "",
);
const assetsCount = computed<number>(() => {
  return (
    (store.newArtwork.thumbnail ? 1 : 0) +
    (store.newArtwork.gallery?.length || 0)
  );
});

const handleFileUpload = async (file: File) => {
  if (!file) return;
  const folder =
    `artworks/${user.value?._id}` ||
    `artworks/${user.value?.email}` ||
    `artworks/${user.value?.name}` ||
    "artworks";

  const thumbNailUrl = await uploadStore.optimizeAndUpload(
    file,
    folder,
    fileName.value,
  );
  if (!thumbNailUrl) return;
  if (store.newArtwork.thumbnail) {
    store.setGalleryImage(thumbNailUrl);
  } else {
    store.setThumbnail(thumbNailUrl);
  }
};

const handleDelete = async (url: string) => {
  currentItem.value = url;
  await store.unsetImage(url);
  currentItem.value = null;
};

const makeMainImage = (url: string) => {
  const oldMain = store.newArtwork.thumbnail;

  store.setThumbnail(url);
  store.removeToReplaceImage(url);

  if (oldMain) {
    store.setGalleryImage(oldMain);
  }
};
</script>
